export const formValidator = (state, dispatch) => {
    let hasError = false;
    for (let param in state) {
        if (state[param].min || state[param].max) {
            // Min Error
            if (state[param].min) {
                if (state[param].value.length < state[param].min) {
                    hasError = true;
                    dispatch({ type: 'ADD_ERROR', param: param, message: `${param} needs to be at least ${state[param].min} characters` });
                }
            }

            // Max Error
            if (state[param].max) {
                if (state[param].value.length > state[param].max) {
                    hasError = true;
                    dispatch({ type: 'ADD_ERROR', param: param, message: `${param} needs to be less than ${state[param].max} characters` });
                }
            }
        }
    }

    return hasError;
};